import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { grantAccess } from "@/components/triarch/TriarchHeader";

export const FinalCTA = () => (
  <section
    id="access"
    data-testid="final-cta-section"
    className="relative scroll-mt-24 overflow-hidden py-32 sm:py-40"
  >
    <div
      className="pointer-events-none absolute inset-0"
      style={{
        background:
          "radial-gradient(720px 420px at 50% 50%, rgba(215,220,227,0.1), rgba(7,8,10,0) 60%)",
      }}
    />
    <div className="relative mx-auto max-w-4xl px-5 text-center sm:px-8">
      <motion.span
        initial={{ opacity: 0, y: 12 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
        className="inline-block font-mono-accent text-[10px] uppercase tracking-[0.3em] text-white/35"
      >
        // Access
      </motion.span>
      <motion.h2
        data-testid="final-cta-headline"
        initial={{ opacity: 0, y: 18 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.85, ease: [0.22, 1, 0.36, 1] }}
        className="mt-6 font-display text-3xl font-semibold leading-[1.12] tracking-[0.02em] text-white text-glow sm:text-5xl lg:text-6xl"
      >
        Aditus non patet.
        <br className="hidden sm:block" /> Eligitur.
      </motion.h2>
      <motion.div
        initial={{ opacity: 0, y: 18 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.85, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
        className="mt-10 flex justify-center"
      >
        <button
          data-testid="final-cta-request-access-button"
          onClick={grantAccess}
          className="group inline-flex items-center gap-2 rounded-full bg-white px-7 py-3.5 font-mono-accent text-xs uppercase tracking-[0.18em] text-[#07080A] transition-all duration-300 hover:shadow-[0_0_46px_rgba(203,174,120,0.34)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/40"
        >
          Request Access
          <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </button>
      </motion.div>
    </div>
  </section>
);
